export enum CreditExternalSource {
  Ecom = 'ECOM',
  Jobs = 'JOBS',
  Jobup = 'JOBUP',
  Salesforce = 'SALESFORCE',
}

// Lifecycle of the credit itself. Stopped and expired belong to CreditRedemptionState.
// Inactive has no consumers here; it stays until the API is confirmed never to emit 'INACTIVE'.
export enum CreditState {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Refund = 'REFUND',
}

export const isCreditState = (creditState: string): creditState is CreditState =>
  Object.values(CreditState).includes(creditState as CreditState);

export enum ExtendCreditType {
  TypeA = 'A',
  TypeB = 'B',
}
